import { Cake, User, Phone } from "lucide-react";
import { formatDate } from "@/lib/time";
import { Patient } from "../types";
import { formatPhone } from "@/lib/string";
import { twMerge } from "tailwind-merge";
import { CopyMrnButton } from "./CopyMrnButton";
import { IconLabel, Skeleton, SkeletonProps } from "@clarityos/ui";

interface PatientMetaProps {
  patient: Pick<Patient, "dateOfBirth" | "mrn" | "phone">;
}

export function PatientMeta({ patient }: PatientMetaProps) {
  return (
    <span className="flex flex-wrap items-center gap-2">
      {patient.dateOfBirth && (
        <IconLabel icon={Cake}>{formatDate(patient.dateOfBirth)}</IconLabel>
      )}
      <span className="inline-flex items-center gap-1">
        <IconLabel icon={User} className="tabular-nums">
          {patient.mrn}
        </IconLabel>
        <CopyMrnButton mrn={patient.mrn} />
      </span>
      {patient.phone && (
        <IconLabel icon={Phone}>{formatPhone(patient.phone)}</IconLabel>
      )}
    </span>
  );
}

export function PatientMetaSkeleton({
  className,
  active = true,
  ...props
}: SkeletonProps) {
  return (
    <Skeleton
      {...props}
      active={active}
      className={twMerge("h-[18px] w-[280px]", className)}
    />
  );
}
